import React, { useState, useEffect } from 'react';
import { AstraGameReport, downloadAstraReport, downloadSavedAstraReports, saveAstraReport } from '../../services/zodiacEngine/AI/AstraAI/AstraReport';
import styles from './ChallengeAI.module.css';

export default function AstraReview({report}:{report:AstraGameReport|null}) {
  const [notes,setNotes]=useState('');
  const [saved,setSaved]=useState(true);
  useEffect(()=>{setNotes(report?.expertNotes||'');if(report) setSaved(saveAstraReport(report));},[report]);
  if(!report) return null;
  return <section className={styles.astraReview} aria-label="ZSTR game review">
    <h3>ZSTR game review</h3>
    <p>{report.version} · {report.models.light} vs {report.models.dark}</p>
    <ul>{report.summary.map((line,i)=><li key={i}>{line}</li>)}</ul>
    <details><summary>Questions for Dion</summary>
      <ol>{report.reviewQuestions.map(q=><li key={q}>{q}</li>)}</ol>
    </details>
    <label htmlFor="astra-review-notes">Your analysis and suggested line</label>
    <textarea id="astra-review-notes" value={notes} rows={4} onChange={e=>{
      setNotes(e.target.value);setSaved(saveAstraReport({...report,expertNotes:e.target.value}));
    }}/>
    <button onClick={()=>downloadAstraReport({...report,expertNotes:notes})}>Download game data</button>
    {saved && <button onClick={downloadSavedAstraReports}>Download saved games</button>}
    <p>{saved?'Saved in this browser (latest 10 games).':'Browser storage is unavailable or full; download to keep this report.'}</p>
    <p>Includes positions, search lines, timing and evaluation components. Suggested turning points need your review.</p>
  </section>;
}
